var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#edf0f4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "m15.956 6.4-.127.432v12.545l.127.127 5.823-3.442z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "m15.956 6.4-5.823 9.662 5.823 3.442z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3c3b",
    d: "m15.956 20.606-.072.088v4.468l.072.21 5.827-8.206z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M15.956 25.372v-4.766l-5.823-3.44z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "m15.956 19.504 5.823-3.442-5.823-2.647z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "m10.133 16.062 5.823 3.442v-6.089z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthh);
export default __webpack_public_path__ + "static/media/ethh.77b36c754c22e005d85ea58dc4f5720d.svg";
export { ForwardRef as ReactComponent };